import * as React from 'react';
import { connect } from 'react-redux';
import { AdminHrisParticipants } from '../../components/pages/survey-admin/AdminHrisParticipants';
import { IApplicationState } from '../../store';
import { ActionCreators as DistributionContactActionCreators } from '../../store/DistributionContactStore';
import { ActionCreators as DistributionFileActionCreators } from '../../store/DistributionFileStore';
import { ActionCreators as DistributionHierarchyActionCreators } from '../../store/DistributionHierarchyStore';
import { ActionCreators as ExternalHierarchyActionCreators } from '../../store/ExternalHierarchyStore';
import { NavigationActions } from '../../store/NavigationActions';
import { ActionCreators as SurveyParticipantActionCreators } from '../../store/SurveyParticipantStore';

export const AdminHierarchyViewPage: React.ComponentType<{ surveyId: number; audienceId: number }> = connect(
	(state: IApplicationState) => ({
		...state.surveyAdmin,
		...state.distributionList,
		...state.distributionHierarchy,
		...state.distributionContacts,
		...state.surveyParticipants,

		surveyStatus: state.surveyAdmin?.surveyAdminSummary?.surveyStatus,
		initializingHierarchy: !!state.Hierarchy.isLoading && !state.Hierarchy.hierarchyHeader,
	}),
	{
		...DistributionFileActionCreators,
		...DistributionHierarchyActionCreators,
		...ExternalHierarchyActionCreators,
		...SurveyParticipantActionCreators,
		...DistributionContactActionCreators,
		Navigate: NavigationActions.Navigate,
	},
)(AdminHrisParticipants);
